import React, { useEffect } from "react";

const AlphaGalModal = ({ onClose }) => {
  useEffect(() => {
    const handleEscape = (e) => {
      if (e.key === "Escape") {
        onClose();
      }
    };

    document.addEventListener("keydown", handleEscape);
    return () => document.removeEventListener("keydown", handleEscape);
  }, [onClose]);

  return (
    <div className="modal-overlay" onClick={onClose}>
      <div className="modal-content" onClick={(e) => e.stopPropagation()}>
        <button className="modal-close" onClick={onClose}>
          ×
        </button>

        <h2 style={{ color: "#2c3e50", marginBottom: "1rem" }}>
          ℹ️ About Alpha-Gal Syndrome
        </h2>

        <div style={{ lineHeight: "1.6", color: "#333" }}>
          <p>
            <strong>Alpha-Gal Syndrome (AGS)</strong> is a type of food allergy
            to red meat and other products made from mammals. In the United
            States, the condition most often begins when a Lone Star tick bites
            someone and transmits a sugar molecule called alpha-gal into the
            person's body.
          </p>

          <h3 style={{ marginTop: "1.5rem", marginBottom: "0.5rem" }}>
            Common Symptoms:
          </h3>
          <ul style={{ marginLeft: "1.5rem", marginBottom: "1rem" }}>
            <li>Hives or itchy rash</li>
            <li>Nausea or vomiting</li>
            <li>Heartburn or indigestion</li>
            <li>Diarrhea</li>
            <li>Cough, shortness of breath, or difficulty breathing</li>
            <li>Drop in blood pressure</li>
            <li>Swelling of the lips, throat, tongue, or eyelids</li>
            <li>Dizziness or faintness</li>
            <li>Severe stomach pain</li>
          </ul>

          <h3 style={{ marginTop: "1.5rem", marginBottom: "0.5rem" }}>
            Foods to Avoid:
          </h3>
          <ul style={{ marginLeft: "1.5rem", marginBottom: "1rem" }}>
            <li>Red meat (beef, pork, lamb, venison, etc.)</li>
            <li>Mammalian products (gelatin, lard, etc.)</li>
            <li>Some medications and medical products</li>
            <li>Dairy products (in some cases)</li>
          </ul>

          <h3 style={{ marginTop: "1.5rem", marginBottom: "0.5rem" }}>
            Safe Alternatives:
          </h3>
          <ul style={{ marginLeft: "1.5rem", marginBottom: "1rem" }}>
            <li>Poultry (chicken, turkey, duck)</li>
            <li>Fish and seafood</li>
            <li>Plant-based proteins</li>
            <li>Fruits and vegetables</li>
            <li>Grains and legumes</li>
          </ul>

          <h3 style={{ marginTop: "1.5rem", marginBottom: "0.5rem" }}>
            Reputable Sources:
          </h3>
          <ul style={{ marginLeft: "1.5rem", marginBottom: "1rem" }}>
            <li>
              <a
                href="https://www.cdc.gov/alpha-gal-syndrome/about/index.html"
                target="_blank"
                rel="noopener noreferrer"
              >
                CDC - Alpha-Gal Syndrome Information
              </a>
            </li>
            <li>
              <a
                href="https://www.aaaai.org/tools-for-the-public/conditions-library/allergies/alpha-gal-and-red-meat-allergy"
                target="_blank"
                rel="noopener noreferrer"
              >
                AAAAI - Alpha-Gal and Red Meat Allergy
              </a>
            </li>
            <li>
              <a
                href="https://www.yalemedicine.org/conditions/alpha-gal-syndrome-ags"
                target="_blank"
                rel="noopener noreferrer"
              >
                Yale Medicine - Alpha-Gal Syndrome
              </a>
            </li>
          </ul>

          <p
            style={{ marginTop: "1.5rem", fontStyle: "italic", color: "#666" }}
          >
            <strong>Important:</strong> This app is for informational purposes
            only and should not replace professional medical advice. Always
            consult with your healthcare provider about Alpha-Gal syndrome and
            food safety.
          </p>
        </div>

        <button className="modal-close-btn" onClick={onClose}>
          Close
        </button>
      </div>
    </div>
  );
};

export default AlphaGalModal;
